import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField } from '@mui/material';
import { numberWithCommas, toEnglishNumber } from '../../utils/formatNumber';

// ----------------------------------------------------------------------

RHFNumberField.propTypes = {
  name: PropTypes.string,
};

export default function RHFNumberField({ name, max_decimal = 0, inputMode, type, ...other }) {
  const { control, setValue, getValues } = useFormContext();
  let regex = max_decimal > 0 ? /(?!,)(?!.)[^0-9]/g : /(?!,)[^0-9]/g;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          error={!!error}
          helperText={error?.message}
          {...other}
          value={numberWithCommas(getValues(name))}
          sx={{ zIndex: '0' }}
          inputMode={inputMode}
          type={type}
          onChange={(event) => {
            let onlyNums = event.target.value.replace(regex, '');
            onlyNums = toEnglishNumber(onlyNums);
            if (onlyNums.split('.')[1]) {
              onlyNums.split('.')[1].length <= max_decimal && setValue(name, onlyNums.replaceAll(',', ''));
            } else {
              setValue(name, onlyNums.replaceAll(',', ''));
            }
          }}
        />
      )}
    />
  );
}
